import { JOURNEY_TYPES } from "core/constants";

export const ONB_THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
}

export const JOURNEY_TEMPLATE = {
  INDIVIDUAL: 'individual',
  HUF: 'HUF_ONBOARDING',
  NRI: 'NRI_ONBOARDING',
}

export const JOURNEY_TEMPLATE_OPTIONS = [
  { value: 'individual', label: 'Individual Account (Indian Resident)', description: 'Open a personal investment account to invest in stocks, mutual funds & more' },
  { value: 'HUF_ONBOARDING', label: 'HUF Account', description: 'Open an account for your family unit (Hindu Undivided Family) to invest and manage wealth collectively' },
  { value: 'NRI_ONBOARDING', label: 'NRI Account', description: 'Invest in Indian markets (stocks, mutual funds and more) as a Non-Resident Indian' },
]

export const MOBILE_LAYOUT_MAX_WIDTH_PX = 750;

export const APP_DOWNLOAD_URL = 'https://app.groww.in/v3cO/4a6424fe';
export const DIGIO_HUF_LINK = 'https://app.digio.in/#/gateway/ekyc/open/KTP260130192230017DXDEHZR18FC6UD';


export const BROADCAST_CONSTANT = {
  LOGOUT: 'LOGOUT',
};

export const HUF_NAME_CONFIG = {
  title: 'Enter the HUF name as per PAN',
  description: 'Name should match the HUF entity name mentioned on the HUF PAN card.',
};

export const WEBVIEW_EVENTS_ACTION_TYPES = {
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  TWO_FACTOR_EXPIRE: 'TWO_FACTOR_EXPIRE',
  AT_RT_UPDATE: 'AT_RT_UPDATE',
  BACK: 'BACK',
  ORIENTATION_CHANGE: 'ORIENTATION_CHANGE',
  AUTO_ROTATE: 'AUTO_ROTATE',
};

export const FNO_SCREENS = {
  USER_BANK_LIST: 'USER_BANK_LIST',
  BANK_SELECTION: 'BANK_SELECTION',
  BUSINESS_FLAG: 'BUSINESS_FLAG',
} as const;

export const VALID_JOURNEY_TYPES = new Set(Object.values(JOURNEY_TYPES));
export const DATA_TYPE_PATTERN = /^[A-Za-z0-9_]{1,100}$/;

export const POST_ONB_NOMINEE_REDIRECTION = 'post-onb-nominee-redirection';

export const NOMINEE_RECHECK_SUMMARY_TIMEOUT_MS = 2000;
export const NOMINEE_RECHECK_RESOLVE_GRACE_MS = 1500;
